import React, {Component} from "react";
import {Navigate} from "react-router-dom";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {LocalStorage} from "../../utils/LocalStorage";
import {LoginWithGoogle} from "../login/LoginWithGoogle";
import {withTranslation} from "react-i18next";
import dashboLogo from '../../images/logo_dashbo_purple.svg';
import '../shopify_merchant/ShopifyMerchant.scss';

const CODE_MIN_LENGTH = 4;

/**
 * Onboarding logueado del cliente vía código de conexión (DSH-).
 *
 * El cliente llega de dos formas:
 *  - Con el link de la agencia (`?prefill_code=DSH-...`): el código viene pre-cargado.
 *  - Instalando la app de Shopify directo (sin link): llega con `shop`/`hmac` pero sin código,
 *    e ingresa el código que le dio su agencia a mano en esta pantalla.
 * Se loguea con Google, el backend lo reconoce vía el código (LogInGoogleUserRedeemingCode), lo
 * asocia a su cliente con el permiso de conexiones, y lo llevamos al Portal a conectar (arrastrando
 * el `shop` para pre-cargar la tienda). Reemplaza el install-sin-login de Shopify.
 */
class ConnectWithCode extends Component {
    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        this.state = {
            // `prefill_code` viene del link de la agencia; si instaló directo desde Shopify queda
            // vacío y el usuario lo ingresa a mano. NUNCA usar `code` (es el OAuth code de Shopify).
            code: (params.get('prefill_code') || '').trim().toUpperCase(),
            shop: (params.get('shop') || '').trim(),
            done: false,
            error: null,
        };
        this.handleGoogleLoginSuccessful = this.handleGoogleLoginSuccessful.bind(this);
        this._onCodeChange = this._onCodeChange.bind(this);
    }

    _onCodeChange(e) {
        const raw = e.target.value.toUpperCase().replace(/[^A-Z0-9-]/g, '');
        this.setState({code: raw, error: null});
    }

    _codeIsValid() {
        return this.state.code.trim().length >= CODE_MIN_LENGTH;
    }

    handleGoogleLoginSuccessful(accountData) {
        const payload = {...accountData, code: this.state.code.trim()};
        new APIClient(API_URL + 'connection-codes/login-redeem/').call('POST', payload)
            .then((response) => this._handleResponse(response));
    }

    _handleResponse(response) {
        const {t} = this.props;
        if (response && response.status === 'OK' && response.data && response.data.logged_user_data) {
            const u = response.data.logged_user_data;
            LocalStorage.saveUserData(
                u.user_id, u.token, u.user_type, u.agency_status, u.language,
                u.client_id || null, u.is_dashbo_mcp, u.free_trial_days_remaining,
                u.agency_logo_url, u.agency_display_name, u.brand_primary_color, u.brand_secondary_color, u.portal_theme);
            LocalStorage.saveUserClients(u.clients || null);
            this.setState({done: true});
            return;
        }
        this.setState({error: (response && response.error_message) || t('connect_with_code.generic_error')});
    }

    render() {
        const {t} = this.props;

        if (this.state.done) {
            // Arrastramos el shop (si vino en la URL de instalación) para pre-cargar la tienda en el Portal.
            const to = this.state.shop
                ? `/portal/connections?shop=${encodeURIComponent(this.state.shop)}`
                : '/portal/connections';
            return <Navigate to={to}/>;
        }

        const codeIsValid = this._codeIsValid();

        return (
            <div className="merchant-install-page">
                <div className="merchant-install-card">
                    <img
                        src={dashboLogo}
                        alt="Dashbo"
                        className="merchant-install-logo"
                    />
                    <h1>{t('connect_with_code.title')}</h1>
                    <p>{t('connect_with_code.subtitle')}</p>

                    <form onSubmit={(e) => e.preventDefault()}>
                        <input
                            type="text"
                            className="form-control"
                            value={this.state.code}
                            onChange={this._onCodeChange}
                            placeholder="DSH-XXXXXXXX"
                            autoFocus
                            maxLength={20}
                        />
                    </form>

                    {this.state.error && <p className="error-text">{this.state.error}</p>}

                    {codeIsValid ? (
                        <LoginWithGoogle
                            onGoogleLoginSucessful={this.handleGoogleLoginSuccessful}
                            buttonText={t('connect_with_code.login_button')}
                        />
                    ) : (
                        <p className="merchant-install-help">{t('connect_with_code.enter_code_hint')}</p>
                    )}

                    <p className="merchant-install-help">{t('connect_with_code.no_code_help')}</p>
                </div>
            </div>
        );
    }
}

export default withTranslation()(ConnectWithCode);
